var _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.69 18.374l2.31 2.31M6.31 18.374L4 20.684",
    stroke: "#F05",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.75,
    stroke: "#F05",
    strokeWidth: 1.5,
    r: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6.5 3.25c1.3.002 2.492.722 3.1 1.87a7.886 7.886 0 00-3.26 1.97 8.116 8.116 0 00-1.73 2.59A3.458 3.458 0 013 6.75a3.504 3.504 0 013.5-3.5zM17.5 3.25a3.504 3.504 0 013.5 3.5 3.458 3.458 0 01-1.61 2.93 8.115 8.115 0 00-1.73-2.59 7.887 7.887 0 00-3.26-1.97 3.516 3.516 0 013.1-1.87z",
    stroke: "#F05",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.233 11.601l-2.79 2.79-1.678-1.672",
    stroke: "#F05",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgClock;